import { Injectable } from '@angular/core';
import { ApiRequestService, HttpRequestType } from '../OffService/api-request.service';
import { SyncService } from '../OffService/sync.service';
import { RequestHandler } from '../OffService/request-handler';
import { VisitasVariedadMesModel } from '../../models/visitas_variedad_mes/visitas_variedad_mes.model';

@Injectable({
  providedIn: 'root'
})

export class SiexApiService {

  public comunidadesAutonomasGET = new RequestHandler<VisitasVariedadMesModel[]>();
  
  public cultivosGET = new RequestHandler<VisitasVariedadMesModel[]>();

  public variedadesGET = new RequestHandler<VisitasVariedadMesModel[]>();

  public vistaCultivoVariedadGET = new RequestHandler<VisitasVariedadMesModel[]>();

  public variedadesClienteGET = new RequestHandler<VisitasVariedadMesModel[]>();
  
  public portainjertosGET = new RequestHandler<VisitasVariedadMesModel[]>();

  public buenasPracticasFertilizantesGET = new RequestHandler<VisitasVariedadMesModel[]>();

  public buenasPracticasRiegoGET = new RequestHandler<VisitasVariedadMesModel[]>();

  public sistemasRiegoGET = new RequestHandler<VisitasVariedadMesModel[]>();

  public metodosFertiGET = new RequestHandler<VisitasVariedadMesModel[]>();
  
  public tiposFertiGET = new RequestHandler<VisitasVariedadMesModel[]>();

  public justificacionesActuacionGET = new RequestHandler<VisitasVariedadMesModel[]>();

  public actividadesSobreCubiertaGET = new RequestHandler<VisitasVariedadMesModel[]>();

  public especiesAnimalesGET = new RequestHandler<VisitasVariedadMesModel[]>();

  constructor(
    private readonly syncService: SyncService<VisitasVariedadMesModel[]>, 
    private readonly api: ApiRequestService<VisitasVariedadMesModel[]>
  ) {
    this.defineComunidadesAutonomasGET();
    this.defineCultivos();
    this.defineVariedades();
    this.defineVistaCultivoVariedad();
    this.defineVariedadesCliente();
    this.definePortainjertos();
    this.defineBuenasPracticasFertilizantes();
    this.defineBuenasPracticasRiego();
    this.defineMetodosFerti();
    this.defineTiposFerti();
    this.defineSistemasRiego();
    this.defineJustificacionesActuacionGET();
    this.defineActividadesSobreCubiertaGET();
    this.defineEspeciesAnimalesGET();
  }

  public defineComunidadesAutonomasGET(): void {
    this.comunidadesAutonomasGET.fetch(HttpRequestType.GET, 'generic/_comunidades_autonomas');
    this.api.registerRequest(this.comunidadesAutonomasGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.comunidadesAutonomasGET));
  }

  public defineCultivos(): void {
    this.cultivosGET.fetch(HttpRequestType.GET, 'cultivo_variedad/get_cultivos');
    this.api.registerRequest(this.cultivosGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.cultivosGET));
  }

  public defineVariedades(): void {
    this.variedadesGET.fetch(HttpRequestType.GET, 'cultivo_variedad/get_variedades');
    this.api.registerRequest(this.variedadesGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.variedadesGET));
  }

  public defineVistaCultivoVariedad(): void {
    this.vistaCultivoVariedadGET.fetch(HttpRequestType.GET, 'generic/vista_cultivo_variedad');
    this.api.registerRequest(this.vistaCultivoVariedadGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.vistaCultivoVariedadGET));
  }

  public defineVariedadesCliente(): void {
    this.variedadesClienteGET.fetch(HttpRequestType.GET, 'generic/vista_variedades_cliente');
    this.api.registerRequest(this.variedadesClienteGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.variedadesClienteGET));
  }
  
  public definePortainjertos(): void {
    this.portainjertosGET.fetch(HttpRequestType.GET, 'parcelas/get_portainjertos');
    this.api.registerRequest(this.portainjertosGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.portainjertosGET));
  }

  public defineBuenasPracticasFertilizantes(): void {
    this.buenasPracticasFertilizantesGET.fetch(HttpRequestType.GET, 'generic/_buenas_practicas_fertilizantes');
    this.api.registerRequest(this.buenasPracticasFertilizantesGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.buenasPracticasFertilizantesGET));
  }

  public defineBuenasPracticasRiego(): void {
    this.buenasPracticasRiegoGET.fetch(HttpRequestType.GET, 'generic/_buenas_practicas_riego');
    this.api.registerRequest(this.buenasPracticasRiegoGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.buenasPracticasRiegoGET));
  }

  public defineMetodosFerti(): void {
    this.metodosFertiGET.fetch(HttpRequestType.GET, 'generic/_metodos_aplicacion_fertilizante');
    this.api.registerRequest(this.metodosFertiGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.metodosFertiGET));
  }

  public defineTiposFerti(): void {
    this.tiposFertiGET.fetch(HttpRequestType.GET, 'generic/_tipos_fertilizacion');
    this.api.registerRequest(this.tiposFertiGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.tiposFertiGET));
  }

  public defineSistemasRiego(): void {
    this.sistemasRiegoGET.fetch(HttpRequestType.GET, 'parcelas/get_sistemas_riego');
    this.api.registerRequest(this.sistemasRiegoGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.sistemasRiegoGET));
  }

  public defineJustificacionesActuacionGET(): void {
    this.justificacionesActuacionGET.fetch(HttpRequestType.GET, 'tareas/justificaciones_get');
    this.api.registerRequest(this.justificacionesActuacionGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.justificacionesActuacionGET));
  }

  public defineActividadesSobreCubiertaGET(): void {
    this.actividadesSobreCubiertaGET.fetch(HttpRequestType.GET, 'tareas/actividades_sobre_cubierta_get');
    this.api.registerRequest(this.actividadesSobreCubiertaGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.actividadesSobreCubiertaGET));
  }

  public defineEspeciesAnimalesGET(): void {
    this.especiesAnimalesGET.fetch(HttpRequestType.GET, 'generic/_especies_animales');
    this.api.registerRequest(this.especiesAnimalesGET);
    this.syncService.register(this.syncService.baseSyncPolicy(this.especiesAnimalesGET));
  }
}
